<section class="saved-card">
  <div class="payment__card-wrapper" *ngIf="!isRemoveCard">
    <div class="payment__card-container">
      <div class="save-card">
        <ion-label color="main-dark" class="save-card__checkbox-text">
          Use saved payment method
        </ion-label>
        <!--              TODO: in future change `checked` attribute to `ngModel` but for now if we use ngmodel “Use saved payment method” still checked after unchecking (on first uncheck) -->
        <ion-checkbox
          color="main-dark"
          class="save-card__checkbox"
          name="save-card"
          [checked]="isSavedPayment"
          [disabled]="paymentStore.createTabChecked"
          (ionChange)="useSavedPayment($event.detail.checked)"
        >
        </ion-checkbox>
      </div>
      <ion-radio-group>
        <ion-item class="payment__card" lines="full" *ngFor="let card of customerCards">
          <ion-radio class="payment__card-radio" color="main-dark" mode="md" *ngIf="customerCards.length > 1"
                     [checked]="isChosenCard(card)"
                     (ionSelect)="choosePaymentCard(card)"></ion-radio>
          <ion-label>{{card.card_brand.replace('AMERICAN_EXPRESS', 'AMEX') + ' ending in ' + card.last4}}</ion-label>
          <ion-button class="payment__card-button ion-float-right" fill="clear" (click)="switchFormForRemoveCard()" color="brand">
            Change
          </ion-button>
        </ion-item>
      </ion-radio-group>
    </div>
  </div>
  <form class="payment__payment-form payment__remove-form" *ngIf="isRemoveCard">
    <div class="payment__card-wrapper">
      <div class="payment__card-container">
        <ion-item class="payment__card" lines="full" *ngFor="let card of paymentStore.customer.cards; let index = index">
          <ion-label>{{card.card_brand + ' ending in ' + card.last4}}</ion-label>
          <ion-button class="ion-float-right" fill="clear" (click)="switchFormForRemoveCard()" color="brand">
            Cancel
          </ion-button>
          <ion-button class="ion-float-right" fill="clear" (click)="removeCard(index)" [disabled]="isRemovalProcess" color="brand">
            <svg class="payment__card-close">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-close"></use>
            </svg>
          </ion-button>
        </ion-item>
      </div>
    </div>
  </form>
</section>
